import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { ElementsWithPMC } from "./ElementsWithPMC";
import { ElementsWithoutPMC } from "./ElementsWithoutPMC";

export const Elements = () => {
  const { currentCommunityProcessorPaymentMethodConfigurationId } =
    usePaywallCheckoutContext();

  if (currentCommunityProcessorPaymentMethodConfigurationId) {
    return <ElementsWithPMC />;
  }

  return <ElementsWithoutPMC />;
};
